import { CustomWindow } from './models/customwindow';

declare let window: CustomWindow;

export const useGeneral = () => {

  const loadImage = (imageElement: HTMLImageElement): Promise<HTMLImageElement> => {
    if (!imageElement) {
      return Promise.reject();
    }

    return new Promise((resolve, reject) => {
      imageElement.onload = () => {
        resolve(imageElement);
      };

      if (imageElement.complete) {
        resolve(imageElement);
      }

      imageElement.onerror = reject;
    });
  };

  const focusTrap = (event: KeyboardEvent, focusableElements: Element[], additionalCondition: boolean | undefined = undefined): void => {
    /*
      Events need to be "default-prevented" before they are sent here.
    */
    setTimeout(() => {
      const isTabPressed = event.key === 'Tab';
      if (!isTabPressed || (additionalCondition != undefined && !additionalCondition)) {
        return;
      }

      const filteredFocusableContent = focusableElements.filter((element) => (element as HTMLElement).offsetHeight > 0);

      const currentIndex = filteredFocusableContent.indexOf(event.target as HTMLElement);
      let nextIndex = currentIndex + (event.shiftKey ? -1 : 1);

      if (nextIndex < 0) {
        nextIndex = filteredFocusableContent.length - 1;
      }

      if (nextIndex >= filteredFocusableContent.length) {
        nextIndex = 0;
      }

      (filteredFocusableContent[nextIndex] as HTMLElement).focus();
    });
  };

  const getTransitionMs = (el: HTMLElement): number => {
    const style = window.getComputedStyle(el);
    const durations = style.transitionDuration
      .split(',')
      .map((v) => v.trim())
      .map((v) => (v.endsWith('ms') ? parseFloat(v) : parseFloat(v) * 1000))
      .filter((n) => Number.isFinite(n));

    return Math.max(0, ...durations, 200); // fallback
  };

  // Normalize string for searching (ignores case, diacritics, extra spaces)
  const normalize = (value: string): string => {
    return value
      .toLowerCase()
      .normalize('NFD')
      // Removes diacritics (å/ä/ö still match if user types a/o)
      .replace(/\p{Diacritic}/gu, '')
      .replace(/\s+/g, ' ')
      .trim();
  };

  return {
    loadImage,
    focusTrap,
    getTransitionMs,
    normalizeString: normalize
  };
};

window.addEventListener('CookiebotOnLoad', () => {
  if (!document.body.classList.contains("cookiebot-loaded")) {
    document.body.classList.add("cookiebot-loaded");
  }
});